import { FaInstagram } from "react-icons/fa";

export default function Booking() {
  return (
    <section id="booking" className="booking-section text-center py-10">
      
      <h3 className="text-lg font-semibold mb-3">
        📍 5015 Backlick Rd #B, Annandale, VA 22003
      </h3>

      <h4 className="mb-4">
        Hours: 10AM - 6PM
      </h4>

      {/* Instagram */}
      <section id="revived-insta" className="link-insta" style={{ margin: "15px 0" }}>
        <a
          href="https://www.instagram.com/revivedhairco?igsh=MmFleDl1NGh2Y3Ft"
          target="_blank"
          rel="noopener noreferrer"
          className="insta-link"
        >
          <FaInstagram size={36} />
        </a>
      </section>

      {/* Directions Button */}
      <a
        href="https://www.google.com/maps?q=5015+Backlick+Rd+%23B,+Annandale,+VA+22003"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="booking-btn bg-red-500 text-white px-6 py-2 rounded-lg shadow-md hover:bg-red-600 transition">
          Directions
        </button>
      </a>
    </section>
  );
}

